import React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { socials } from "../data/site";

const ICONS = {
  github: GitHubIcon,
  linkedin: LinkedInIcon,
  email: MailOutlineIcon,
};

/** GitHub / LinkedIn / email row, shared by the hero and the footer. */
const SocialLinks = ({ size = "large", justify = "center", sx }) => (
  <Box sx={{ display: "flex", gap: 1, justifyContent: justify, ...sx }}>
    {socials.map(({ label, href, icon }) => {
      const Icon = ICONS[icon];
      const isMail = href.startsWith("mailto:");

      return (
        <IconButton
          key={label}
          component="a"
          href={href}
          aria-label={label}
          {...(isMail ? {} : { target: "_blank", rel: "noopener noreferrer" })}
          sx={{
            // The palette is monochrome by design, so the hover state is a
            // background wash rather than MUI's default primary blue.
            color: "text.secondary",
            "&:hover": {
              color: "text.primary",
              backgroundColor: "action.hover",
            },
          }}
        >
          <Icon fontSize={size} />
        </IconButton>
      );
    })}
  </Box>
);

export default SocialLinks;
